export default __webpack_public_path__ + "static/media/2_PRESTIGIO_CALACATTA_ORO_120x278_265.408cd78a.jpg";